export enum ApiResultValues{
    Ok = "Ok",
    NotFound = "NotFound",
    ParameterError = "ParameterError",
    LogicalError = "LogicalError",
    Exception = "Exception",
    NotSpecified = "NotSpecified",
    ExternalDataError = "ExternalDataError"
}

export interface IApiResultBase {
    result: ApiResultValues;
    message: string;
    error?: any;
    externalDataResult?: string;
}   

export interface IApiResult extends IApiResultBase {
    data: any;
}

export interface IApiQueryResult extends IApiResultBase {
    data: any[];
    count: number;
}